import React, {Component} from 'react';
import classnames from 'classnames';

import {
    mapCardTypeToCss
} from "../../lib/payment-method-util"

/**
 * Component to display credit o debit card
 */
class PaymentMethodCreditOrDebitCard extends Component {
    render() {
        const {
            code, description, cardHolderName,
            accountNumber, month, year
        } = this.props;

        return (
            <div className="card-container">
                <div className="pm-card-chip"/>
                <p className="pm-info card-number">{accountNumber}</p>
                {month && year && (
                    <div>
                        <p className="pm-info card-exp-label">Valid <br/>Thru</p>
                        <p className="pm-info card-exp-date">{month}<span className="card-sep">/</span>{year}</p>
                    </div>
                )}
                <p className="pm-info card-name">{cardHolderName}</p>
                <p className="pm-info card-type">
                    <span className={classnames("pm-icon", mapCardTypeToCss(code))}>
                        {description}
                    </span>
                </p>
            </div>
        );
    }
}

export default PaymentMethodCreditOrDebitCard
